var waitFor = require("../utils/waitFor");
var util = require("../utils/misc");

waitFor("#tech-specs-table", function () {
  var dt = require("datatables.net")(window, jQuery),
    dt_fixedheader = require("datatables.net-fixedheader")(window, jQuery),
    dt_fixedcolumns = require("datatables.net-fixedcolumns")(window, jQuery),
    dtUtils = require("../utils/dtUtils");

  // Results table

  var dtOpts = {
    data: dtUtils.formatResultsData(
      window.techSpecsData.data,
      window.techSpecsData.colData
    ),
    columns: dtUtils.buildDataTablesColumns(window.techSpecsData.colData),
    fixedHeader: true,
    fixedColumns: true,
    scrollX: true,
    searching: false,
    lengthChange: false,
    ordering: false,
    info: false,
    autoWidth: false,
    dom: "t",
    drawCallback: function () {
      $("#technical .dataTables_scrollBody").scroll(alignFixedHeaderWithBody);

      // try to fix dataTables_scroll being barely too small
      function fixScrollDivHeight() {
        alignFixedHeaderWithBody();
      }
      setTimeout(fixScrollDivHeight, 100);
    },
  };

  var $leftCoverBar = $('<div class="margin-cover-bar left" />');
  var $rightCoverBar = $('<div class="margin-cover-bar right" />');
  var $topLeftCoverBarAbs = $('<div class="margin-cover-bar top-left abs" />');
  $("body").append($leftCoverBar, $rightCoverBar);
  $("#technical > .container > .comp-list-family").append($topLeftCoverBarAbs);

  function alignFixedHeaderWithBody(e) {
    var scrollLeft = $("#technical .dataTables_scrollBody").scrollLeft();

    $("#tech-specs-table tbody tr:nth-child(1) td").each(function (i, el) {
      var matchingWidth = $(el).width();
      var $fixedTh = $(".fixedHeader-floating th:nth-child(" + (i + 1) + ")");

      if (!$fixedTh[0])
        $fixedTh = $(
          ".dataTables_scrollHeadInner th:nth-child(" + (i + 1) + ")"
        );

      $fixedTh.width(matchingWidth);
    });

    // fix spacer width on fixed header
    var $fixedHeaderSpacer = $(
      "#tech-specs-table_wrapper > div > div.dataTables_scroll > div.dataTables_scrollHead > div > table > thead > tr > th.sorting_disabled.col-emphasize"
    );
    var fixedHeaderSpacerWidth = $fixedHeaderSpacer.data("fixed-width");

    if (!fixedHeaderSpacerWidth) {
      $fixedHeaderSpacer.data("fixed-width", $fixedHeaderSpacer.width() - 32);
    }

    if ($fixedHeaderSpacer.width() != fixedHeaderSpacerWidth) {
      $fixedHeaderSpacer.width(fixedHeaderSpacerWidth);
    }

    // setup coverups
    var screenWidth = $(window).width();
    var containerLeftOffset = 0;
    if (screenWidth >= 1024) {
      var containerWidth = $("#technical > .container").width();
      containerLeftOffset = (screenWidth - containerWidth) / 2;
    }

    var fixedHeaderOffset = -1 * scrollLeft + containerLeftOffset;
    $(".fixedHeader-floating").css("left", fixedHeaderOffset); //fix the thead relative to the body scrolling

    var containerTop = $("#technical").offset().top;
    var scrollTop = $(window).scrollTop();
    var coverTop = containerTop < scrollTop ? 0 : containerTop - scrollTop;

    [$rightCoverBar, $leftCoverBar].forEach(function ($el) {
      $el.css("top", coverTop);
      $el.width(containerLeftOffset);
    });

    // maybe setup fixed head first col cover
    var $fixedHeader = $(".fixedHeader-floating");
    if (
      $fixedHeader.length > 0 &&
      $fixedHeader.find(".col-cover").length === 0
    ) {
      var $colCover = $(
        '<div class="col-cover table-fixed-header-col-cover"></div>'
      )
        .height($fixedHeader.height())
        .width($(".margin-cover-bar.top-left.abs").width() + 20)
        .css("left", containerLeftOffset);

      $fixedHeader.prepend($colCover);
    }
  }

  var dtInstance = $("#tech-specs-table").DataTable(dtOpts);

  // console.log(dtOpts);

  // redraw when siwtching to the tab
  $('[role="tablist"] a[href="#technical"]').click(function () {
    setTimeout(function () {
      dtInstance.draw();
    }, 50);

    $(window).on("scroll.fixHeader", alignFixedHeaderWithBody);

    setTimeout(function sizeTopLeftCover() {
      var $cloneEl = $(".DTFC_Cloned.comp-family-table");
      $topLeftCoverBarAbs.width($cloneEl.width()).height($cloneEl.height());

      // fix width of normal header first col
      setTimeout(function () {
        var $el = $(
          "#tech-specs-table_wrapper > div > div.dataTables_scroll > div.dataTables_scrollHead > div > table > thead > tr > th.sorting_disabled.col-emphasize"
        );
        $el.width($el.width());
      }, 10);
    }, 100);

    $rightCoverBar.show();
    $leftCoverBar.show();
  });

  $('[role="tablist"] a:not([href="#technical"])').click(function () {
    $(window).off("scroll.fixHeader");

    $rightCoverBar.hide();
    $leftCoverBar.hide();
  });

  if (window.location.hash == "#technical")
    $('[role="tablist"] a[href="#technical"]').click();
});
